import { required, email, requiredIf } from 'vuelidate/lib/validators'
import {
  fileSize,
  date,
  dateBefore,
  time,
  iban,
  swift,
  phone,
  zip,
  ticketNo
} from '@/ic-common/helpers/validation'

import { isForeignBank, isBankTransfer, isEmailAgreement } from './helpers'
import moment from 'moment'

export default {
  form: {
    email: {
      required,
      email
    },
    message: {
      required
    },
    agreement: {
      
    },
    name: {
      firstName: { required },
      lastName: { required },
      sex: { required }
    },
    phone: { phone },
    address: {
      street: {  requiredIf: requiredIf(isEmailAgreement)  },
      streetNo: {  requiredIf: requiredIf(isEmailAgreement)  },
      zip: {  requiredIf: requiredIf(isEmailAgreement) , zip },
      city: {  requiredIf: requiredIf(isEmailAgreement)  }
    },
    bank: {
      iban: { requiredIf: requiredIf(isBankTransfer), iban },
      swift: { requiredIf: requiredIf(isForeignBank), swift },
      name: { requiredIf: requiredIf(isForeignBank) },
      accountOwner: { requiredIf: requiredIf(isForeignBank) }
    },
    connection: {
      //   departureStation: { required },
      //   arrivalStation: { required },
      departureDate: {
        date,
        dateBeforeToday: dateBefore(moment().format('YYYY-MM-DD'))
      },
      departureTime: { time },
      ticketNo: { required, ticketNo }
      //   trainNo: { required }
    },
    files: {
      $each: {
        contact_fileSize: fileSize({ min: 0, max: 5000 })
      }
    }
  }
}
